// returns true, if the given email address is valid
// returns false, if not
export function isValidEmailAddress(emailAddress) {
  var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(String(emailAddress).toLowerCase());
}
